import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=f5eeb738&scoped=true&"
import script from "./PartnersPage.vue?vue&type=script&lang=js&"
export * from "./PartnersPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnersPage.vue?vue&type=style&index=0&id=f5eeb738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5eeb738",
  null
  
)

export default component.exports